import { useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useStore } from "@/context/StoreContext";
import { imgSrc, money } from "@/lib/api";

export const CartSheet = () => {
  const { cart, cartOpen, setCartOpen, setQty, total, currency, priceOf } = useStore();
  const nav = useNavigate();
  return (
    <Sheet open={cartOpen} onOpenChange={setCartOpen}>
      <SheetContent className="bg-[#111827] border-white/10 text-slate-100 flex flex-col w-full sm:max-w-md" data-testid="cart-drawer">
        <SheetHeader><SheetTitle className="font-heading text-xl text-white">Seu carrinho</SheetTitle></SheetHeader>
        {cart.length === 0 ? (
          <div className="flex-1 grid place-items-center text-center text-slate-400" data-testid="cart-empty">
            <div><ShoppingBag className="w-10 h-10 mx-auto mb-3 opacity-50" />Seu carrinho está vazio</div>
          </div>
        ) : (
          <div className="flex-1 overflow-y-auto space-y-3 mt-4 pr-1">
            {cart.map((i) => (
              <div key={i.id} className="flex gap-3 p-3 rounded-xl bg-white/5 border border-white/10" data-testid={`cart-item-${i.id}`}>
                <img src={imgSrc(i.image)} alt={i.name} className="w-16 h-16 rounded-lg object-cover" />
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-sm truncate">{i.name}</p>
                  <p className="font-mono text-xs text-slate-400 mt-0.5">{money(priceOf(i), currency)}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <button className="w-7 h-7 rounded-md bg-white/10 hover:bg-white/20 grid place-items-center" onClick={() => setQty(i.id, i.quantity - 1)} data-testid={`cart-item-decrease-${i.id}`}><Minus className="w-3 h-3" /></button>
                    <span className="font-mono text-sm w-6 text-center" data-testid={`cart-item-qty-${i.id}`}>{i.quantity}</span>
                    <button className="w-7 h-7 rounded-md bg-white/10 hover:bg-white/20 grid place-items-center" onClick={() => setQty(i.id, i.quantity + 1)} data-testid={`cart-item-increase-${i.id}`}><Plus className="w-3 h-3" /></button>
                    <button className="ml-auto text-slate-500 hover:text-rose-400" onClick={() => setQty(i.id, 0)} data-testid={`cart-item-remove-${i.id}`}><Trash2 className="w-4 h-4" /></button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        {cart.length > 0 && (
          <div className="border-t border-white/10 pt-4 space-y-3">
            <div className="flex justify-between items-baseline">
              <span className="text-slate-400 text-sm">Subtotal</span>
              <span className="font-mono text-2xl font-bold" data-testid="cart-subtotal">{money(total(), currency)}</span>
            </div>
            <Button className="w-full h-12 rounded-full bg-violet-600 hover:bg-violet-500 text-white font-semibold" data-testid="cart-checkout-button"
              onClick={() => { setCartOpen(false); nav("/checkout"); }}>
              Finalizar compra
            </Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
